const Style = {
    container: 'py-4 flex items-center justify-between',
    actions: 'flex items-center space-x-2',
};
export default Style;
